import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../store/spirs/types";
import {SWITCH_DISPLAY_PERIOD_MARKETS} from "../../store/spirs/actions";
import {useTranslation} from "react-i18next";

export const SwitcherChildBlocks = React.memo(() => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const isDisplayPeriodMarkets = useSelector((state: StoreType) => state.appSettings.displayPeriodMarkets);
    const handleChange = ({target: {checked}}: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(SWITCH_DISPLAY_PERIOD_MARKETS(checked));
    };

    return (
        <div className="flex items-center gap-[12px]">
            <span className="text-[14px] text-[#ABABAB]">{t('displayPeriodMarkets')}</span>
            <label className="flex items-center relative cursor-pointer select-none">
                <input type="checkbox" checked={isDisplayPeriodMarkets} onChange={handleChange} className="peer bg-[#8C90A2] appearance-none transition-colors border border-[#8C90A2] cursor-pointer w-[35px] h-[18px] rounded-full" />
                <span className="peer-checked:absolute peer-checked:w-full peer-checked:h-full peer-checked:rounded-full peer-checked:bg-[#D32F2F]"/>
                <span className="peer-checked:translate-x-[17px] h-[14px] w-[14px] left-[2px] absolute rounded-full transform transition-transform bg-white" />
            </label>
        </div>
    )
}, () => true);
